(() => {
    const SELECTORS = {
        overlay: "[data-drawer-overlay]",
        close: "[data-drawer-close]",
        content: "[data-drawer-content]",
        footer: "[data-drawer-footer]",
        item: "[data-line]",
        qtyMinus: "[data-qty-minus]",
        qtyPlus: "[data-qty-plus]",
        qtyInput: "[data-qty-input]",
        remove: "[data-remove]",
        urgency: "[data-urgency]",
        urgencyFill: "[data-urgency-fill]",
        savingsWrap: "[data-cart-savings]",
        savingsAmount: "[data-savings-amount]",
    };
    let lastUrgencyStepFired = 0;
    const GIFT_WRAP_VARIANT_ID = 52550245974330;

    function isOnlyGiftWrap(cart) {
        return (
            cart.items.length === 1 &&
            cart.items[0].variant_id === GIFT_WRAP_VARIANT_ID
        );
    }

    function calculateCartSavings(cart) {
        if (!cart || !cart.items) return 0;

        // cart.total_discount includes automatic + coupon code discounts
        if (cart.total_discount && cart.total_discount > 0) {
            return cart.total_discount / 100;
        }

        // Fallback: item-level discount calculation
        return cart.items.reduce(function(sum, item) {
            return sum + Math.max(0, item.original_line_price - item.final_line_price);
        }, 0) / 100;
    }

    function toggleEmptyState(container, cart) {
        const nonEmpty = container.querySelector('[data-cart-non-empty]');
        const wearWithIt = container.querySelector('[data-wear-with-it]');

        const isEmpty =
            cart.item_count === 0 ||
            isOnlyGiftWrap(cart); // 🔥 IMPORTANT

        if (nonEmpty) nonEmpty.style.display = isEmpty ? 'none' : '';
        if (wearWithIt) wearWithIt.style.display = isEmpty ? 'none' : '';
    }


    function updateCartCountBubble(cart) {
        if (!cart) return;

        const count = cart.item_count || 0;

        const update = () => {
            const bubbles = document.querySelectorAll('.cart-count-bubble');
            if (!bubbles.length) return false;

            bubbles.forEach((bubble) => {
                const visible = bubble.querySelector('span[aria-hidden]');
                const hidden = bubble.querySelector('.visually-hidden');

                if (visible) visible.textContent = count;
                if (hidden) hidden.textContent = `${count} items`;

                bubble.classList.toggle('hidden', count === 0);
            });

            return true;
        };

        // Try immediately
        if (update()) return;

        // Retry after DOM settles
        setTimeout(update, 120);
    }


    let solomonConfettiRunning = false;

    function fireCanvasConfetti() {
        if (solomonConfettiRunning) return;
        solomonConfettiRunning = true;

        const canvas = document.getElementById("confetti");
        if (!canvas) return;

        const ctx = canvas.getContext("2d");

        const resize = () => {
            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
        };
        resize();

        const confettis = [];
        const colors = [
            // ✨ Gold family (base)
            "#FFD700", // classic gold
            "#D4AF37", // rich metallic gold
            "#E8C27D", // soft champagne
            "#F5E6C8", // ivory gold
            "#C9A24D", // antique gold
            "#B89B5E", // muted gold
            "#FFECB3", // pale gold highlight

            // 💎 Jewel tones (premium pop)
            "#6A0DAD", // royal purple
            "#1F3C88", // sapphire blue
            "#0F4C5C", // teal blue
            "#006D5B", // emerald green
            "#8B0000", // deep ruby

            // 🌸 Soft festive accents
            "#FF6F91", // blush pink
            "#FF9671", // peach
            "#FFC75F", // warm yellow
            "#F9F871", // light festive yellow
            "#CDB4DB", // soft lavender

            // 🔮 Modern luxury pops (very subtle)
            "#00B4D8", // aqua blue
            "#90DBF4", // sky blue
            "#F15BB5", // muted magenta
            "#9B5DE5", // violet
            "#4D96FF"  // royal light blue
        ];


        function createConfetti() {
            return {
                x: Math.random() * canvas.width,
                y: -20,
                size: Math.random() * 5 + 4,   // 👈 smaller & premium
                color: colors[Math.floor(Math.random() * colors.length)],
                speedX: Math.random() * 3 - 1.5, // smoother
                speedY: Math.random() * 5 + 2.5, // softer fall
                rotation: Math.random() * 360
            };
        }


        for (let i = 0; i < 180; i++) {
            confettis.push(createConfetti());
        }

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            confettis.forEach((c, i) => {
                c.x += c.speedX;
                c.y += c.speedY;
                c.rotation += c.speedX;

                ctx.save();
                ctx.translate(c.x, c.y);
                ctx.rotate((c.rotation * Math.PI) / 180);
                ctx.fillStyle = c.color;
                ctx.fillRect(-c.size / 2, -c.size / 2, c.size, c.size);
                ctx.restore();

                if (c.y > canvas.height + 20) {
                    confettis.splice(i, 1);
                }
            });

            if (confettis.length > 0) {
                requestAnimationFrame(animate);
            } else {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                solomonConfettiRunning = false;
            }
        }

        animate();
    }

    const Urgency = {
        rafId: null,

        stop() {
            if (this.rafId) cancelAnimationFrame(this.rafId);
            this.rafId = null;
        },

        // ✅ read current % from DOM (works even if inline style missing)
        getPercent(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            const fill = wrap?.querySelector(SELECTORS.urgencyFill);
            if (!wrap || !fill) return 0;

            const inline = parseFloat(fill.style.width);
            if (!Number.isNaN(inline)) return inline;

            const bar = fill.parentElement;
            if (!bar) return 0;

            const barW = bar.getBoundingClientRect().width || 1;
            const fillW = fill.getBoundingClientRect().width || 0;
            return Math.max(0, Math.min(100, (fillW / barW) * 100));
        },

        getTarget(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            if (!wrap) return 0;

            const discountedCount = parseInt(wrap.dataset.discountedCount, 10) || 0;

            if (discountedCount >= 2) return 100;
            if (discountedCount >= 1) return 50;
            return 0;
        },


        paintDots(container) {
            const wrap = container.querySelector(SELECTORS.urgency);
            if (!wrap) return;

            const step = parseInt(wrap.dataset.step, 10) || 0;

            wrap.querySelectorAll(".dot").forEach((dot, i) => {
                dot.classList.toggle("active", i + 1 <= step);
            });
        },


        animate(fill, from, to, duration = 420) {
            this.stop();
            const start = performance.now();

            const frame = (now) => {
                const t = Math.min((now - start) / duration, 1);
                const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
                const value = from + (to - from) * eased;
                fill.style.width = value.toFixed(2) + "%";
                if (t < 1) this.rafId = requestAnimationFrame(frame);
            };

            this.rafId = requestAnimationFrame(frame);
        },

        // ✅ main render: uses "fromOverride" if provided (for smooth 100->50 after DOM replace)
        render(container, fromOverride = null) {
            const wrap = container.querySelector(SELECTORS.urgency);
            const fill = wrap?.querySelector(SELECTORS.urgencyFill);
            if (!wrap || !fill) return;

            const target = this.getTarget(container);
            this.paintDots(container);

            const from = typeof fromOverride === "number"
                ? fromOverride
                : this.getPercent(container);

            const discountedCount = parseInt(wrap.dataset.discountedCount, 10) || 0;

            // Map discounted count → tier
            const prev = this._prevDiscountedCount || 0;

            // 🔥 10% unlock
            if (discountedCount >= 1 && prev < 1) {
                document.dispatchEvent(
                    new CustomEvent("solomon:discount:urgency", {
                        detail: { step: 1, percent: 10 }
                    })
                );
            }

            // 🔥 24% unlock (THIS IS WHAT YOU WANT)
            if (discountedCount >= 2 && prev < 2) {
                document.dispatchEvent(
                    new CustomEvent("solomon:discount:urgency", {
                        detail: { step: 2, percent: 24 }
                    })
                );
            }

            // ✅ save state
            this._prevDiscountedCount = discountedCount;




            // 🔄 Reset if discount drops
            // if (discountStep < lastUrgencyStepFired) {
            //     lastUrgencyStepFired = discountStep === 1 ? 0 : discountStep;
            // }

            if (Math.abs(from - target) > 0.5) {
                this.animate(fill, from, target);
            } else {
                fill.style.width = target + "%";
            }
        }
    };

    const solomonRemoveModal = (() => {

        let drawerRef = null;
        let pendingLine = null;

        function getModal() {
            return document.getElementById("solomon-remove-modal");
        }

        function getWishlistBtn(modal) {
            return modal?.querySelector(".wishlist_button");
        }

        function fillWishlist(row) {
            const modal = getModal();
            const wishlistBtn = getWishlistBtn(modal);
            if (!wishlistBtn || !row) return;

            wishlistBtn.dataset.productId = row.dataset.productId || "";
            wishlistBtn.dataset.productTitle = row.dataset.productTitle || "";
            wishlistBtn.dataset.productImg = row.dataset.productImg || "";
            wishlistBtn.dataset.productPrice = row.dataset.productPrice || "";
            wishlistBtn.dataset.productUrl = row.dataset.productUrl || "";
            wishlistBtn.dataset.productVariantId = row.dataset.productVariantId || "";

            wishlistBtn.classList.remove("active");

            const imgEl = modal.querySelector("[data-product-remove-img]");
            if (imgEl && row.dataset.productImg) {
                imgEl.src = row.dataset.productImg;
                imgEl.alt = row.dataset.productTitle || "Product image";
            }
        }

        function open({ drawer, line, row }) {
            const modal = getModal();
            if (!modal) return;
            if (pendingLine !== null) return;

            drawerRef = drawer;
            pendingLine = line;

            fillWishlist(row);

            modal.hidden = false;
            // document.body.style.overflow = "hidden";
        }

        function close() {
            const modal = getModal();
            if (!modal) return;

            modal.hidden = true;
            // document.body.style.overflow = "";

            drawerRef = null;
            pendingLine = null;
        }

        // 🔥 SAFE EVENT HANDLING
        document.addEventListener("click", (e) => {
            const modal = getModal();
            if (!modal || modal.hidden) return;

            const wishlistBtn = getWishlistBtn(modal);
            if (
                e.target.classList.contains("solomon-remove-modal__overlay") ||
                e.target.classList.contains("solomon-remove-modal__close")
            ) {
                close();
                return;
            }

            // ❌ REMOVE ONLY
            if (e.target.closest("[data-remove-confirm]")) {
                drawerRef?.changeLine(pendingLine, 0);
                close();
                return;
            }

            // ❤️ MOVE TO WISHLIST (100% SAFE)
            if (wishlistBtn && wishlistBtn.contains(e.target)) {
                e.preventDefault();
                e.stopPropagation();

                const key = "wishlist";

                // ✅ FIX #1 — list define karo
                let list = JSON.parse(localStorage.getItem(key)) || [];

                const data = {
                    productId: wishlistBtn.dataset.productId,
                    productTitle: wishlistBtn.dataset.productTitle,
                    productImg: wishlistBtn.dataset.productImg,
                    productPrice: wishlistBtn.dataset.productPrice,
                    productUrl: wishlistBtn.dataset.productUrl,
                    productVariant: wishlistBtn.dataset.productVariantId,
                };

                if (!list.some(i => i.productVariant === data.productVariant)) {
                    list.push(data);
                    localStorage.setItem(key, JSON.stringify(list));

                    // ✅ FIX #2 — event fire
                    document.dispatchEvent(new CustomEvent("wishlist:updated"));
                }

                drawerRef?.changeLine(pendingLine, 0);
                close();
            }
        });

        return { open };
    })();

    function syncGiftWrapCheckboxFromCart(cart, container) {
        const checkbox = container.querySelector('[data-gift-wrap-checkbox]');
        const wrapper = checkbox?.closest('[data-gift-wrap-wrapper]');
        if (!checkbox || !wrapper) return;

        const hasGiftWrap = cart.items.some(
            item => item.variant_id === GIFT_WRAP_VARIANT_ID
        );

        // 🔥 SINGLE SOURCE OF TRUTH = wrapper class
        wrapper.classList.toggle('is-active', hasGiftWrap);

        // Accessibility only (NO UI dependency)
        checkbox.setAttribute('aria-checked', hasGiftWrap ? 'true' : 'false');
    }

    async function removeGiftWrapIfOnlyItem(cart) {
        if (
            cart.items.length === 1 &&
            cart.items[0].variant_id === GIFT_WRAP_VARIANT_ID
        ) {

            await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: cart.items[0].key,
                    quantity: 0
                })
            });

            return true;
        }
        return false;
    }

    class solomonCartDrawer extends HTMLElement {
        constructor() {
            super();
            this.isOpen = false;
            this.isRendering = false;

            this.onOverlay = this.onOverlay.bind(this);
            this.onClose = this.onClose.bind(this);
            this.onKey = this.onKey.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onChange = this.onChange.bind(this);

            this.pendingOpen = false;
        }

        connectedCallback() {
            this.overlayEl = this.querySelector(SELECTORS.overlay);
            this.closeEl = this.querySelector(SELECTORS.close);
            this.contentEl = this.querySelector(SELECTORS.content);
            this.footerEl = this.querySelector(SELECTORS.footer);

            this.overlayEl?.addEventListener("click", this.onOverlay);
            this.closeEl?.addEventListener("click", this.onClose);
            document.addEventListener("keydown", this.onKey);

            document.addEventListener("solomon:cart:added", (e) => {
                this.refresh({ openIfClosed: true });
            });

            this.addEventListener("click", this.onClick);
            this.addEventListener("change", this.onChange);

            document.querySelector("#cart-icon-bubble")?.addEventListener("click", (e) => {
                e.preventDefault();
                this.open();
            });

            this.refresh({ openIfClosed: false });
        }

        disconnectedCallback() {
            this.overlayEl?.removeEventListener("click", this.onOverlay);
            this.closeEl?.removeEventListener("click", this.onClose);
            document.removeEventListener("keydown", this.onKey);
        }

        onOverlay() { this.close(); }
        onClose() { this.close(); }

        onKey(e) {
            if (e.key === "Escape" && this.isOpen) this.close();
        }

        open() {
            // ✅ if drawer is still rendering, just mark pendingOpen
            if (this.isRendering) this.pendingOpen = true;

            if (this.isOpen) return;
            this.isOpen = true;
            this.classList.add("is-open");
            document.body.style.overflow = "hidden"

            // don't render urgency here aggressively; refresh() will handle correct state
            requestAnimationFrame(() => {
                Urgency.render(this);
                fetch("/cart.js")
                    .then(r => r.json())
                    .then(updateCartCountBubble);
            });
        }

        close() {
            if (!this.isOpen) return;
            this.isOpen = false;
            this.classList.remove("is-open");
            document.body.style.overflow = ""
        }

        setLoading(state) {
            this.classList.toggle("is-loading", state);
        }

        setLineLoading(line, state) {
            this.querySelector(`[data-line="${line}"]`)?.classList.toggle("is-loading", state);
        }

        async fetchCart() {
            const res = await fetch("/cart.js", { credentials: "same-origin" });
            return res.json();
        }

        async renderFromSection() {
            const res = await fetch(`/?section_id=solomon-cart-drawer`);
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, "text/html");
            const fresh = doc.querySelector("solomon-cart-drawer");
            if (!fresh) return;

            // 🔁 MAIN CART CONTENT
            this.contentEl.innerHTML =
                fresh.querySelector(SELECTORS.content)?.innerHTML || "";

            this.footerEl.innerHTML =
                fresh.querySelector(SELECTORS.footer)?.innerHTML || "";

            // Reset coupon UI after footer re-render (new product added = fresh coupon form)
            if (window._solomonCouponReset) requestAnimationFrame(window._solomonCouponReset);

            // 🔥 DESKTOP "WEAR WITH IT" — FORCE UPDATE
            const newDesktopWear = fresh.querySelector(".solomon-wear-with-it-desktop__content");
            const oldDesktopWear = this.querySelector(".solomon-wear-with-it-desktop__content");

            if (newDesktopWear && oldDesktopWear) {
                oldDesktopWear.innerHTML = newDesktopWear.innerHTML;
            }

            // 🔁 URGENCY BAR (already correct)
            const newUrgency = fresh.querySelector(SELECTORS.urgency);
            const oldUrgency = this.querySelector(SELECTORS.urgency);
            if (newUrgency && oldUrgency) {
                oldUrgency.outerHTML = newUrgency.outerHTML;
            }
        }


        async refresh({ openIfClosed }) {
            if (this.isRendering) return;
            this.isRendering = true;

            // ✅ capture old urgency % BEFORE DOM replace
            const prevPercent = Urgency.getPercent(this);

            try {
                this.setLoading(true);

                // ✅ 1️⃣ fetch cart ONCE
                const cart = await this.fetchCart();
                // 🔥 AUTO REMOVE GIFT WRAP IF IT'S THE ONLY ITEM
                if (await removeGiftWrapIfOnlyItem(cart)) {
                    const freshCart = await this.fetchCart();
                    updateCartCountBubble(freshCart);
                    toggleEmptyState(this, freshCart);
                    syncGiftWrapCheckboxFromCart(freshCart, this);
                    await this.renderFromSection();
                    initsolomonWearSwiper(this);
                    return; // ⛔ stop further rendering
                }

                updateCartCountBubble(cart);


                // ✅ 2️⃣ render drawer section ONCE
                await this.renderFromSection();
                toggleEmptyState(this, cart);
                syncGiftWrapCheckboxFromCart(cart, this);
                initsolomonWearSwiper(this);

                // ✅ 3️⃣ restore urgency smoothly
                requestAnimationFrame(() => {
                    Urgency.render(this, prevPercent);
                });

                // ✅ 4️⃣ calculate & update savings + total price
                const savings = calculateCartSavings(cart);
                const wrap = this.querySelector(SELECTORS.savingsWrap);
                const amount = this.querySelector(SELECTORS.savingsAmount);

                if (wrap && amount) {
                    amount.textContent = savings.toFixed(0);
                    wrap.style.display = savings > 0 ? "flex" : "none";
                }

                // Update cart total price display with discounted total
                const totalEl = this.querySelector('[data-cart-total]');
                if (totalEl && cart.total_price !== undefined) {
                    const fmt = window.Shopify && window.Shopify.formatMoney
                        ? window.Shopify.formatMoney(cart.total_price, window.Shopify.moneyFormat || '${{amount}}')
                        : '$' + (cart.total_price / 100).toFixed(2);
                    totalEl.textContent = fmt;
                }

                // ✅ 5️⃣ open drawer safely
                if (openIfClosed) this.open();
                if (this.pendingOpen) {
                    this.pendingOpen = false;
                    this.open();
                }

            } catch (err) {
                console.error("solomon drawer error:", err);
            } finally {
                this.setLoading(false);
                this.isRendering = false;
            }
        }


        async changeLine(line, quantity) {
            // this.setLineLoading(line, true);
            try {
                await fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ line, quantity }),
                });
                await this.refresh({ openIfClosed: false });
            } finally {
                // this.setLineLoading(line, false);
            }
        }

        onClick(e) {
            const row = e.target.closest(SELECTORS.item);
            if (!row) return;

            const line = parseInt(row.dataset.line, 10);

            // ❌ REMOVE → OPEN MODAL
            if (e.target.closest(SELECTORS.remove)) {
                e.preventDefault();

                solomonRemoveModal?.open({
                    drawer: this,
                    line,
                    row
                });
                return;
            }

            // ➖ QTY MINUS
            if (e.target.closest(SELECTORS.qtyMinus)) {
                e.preventDefault();
                const input = row.querySelector(SELECTORS.qtyInput);
                const current = parseInt(input.value, 10);

                if (current === 1) {
                    solomonRemoveModal?.open({
                        drawer: this,
                        line,
                        row
                    });
                    return;
                }

                const val = current - 1;
                input.value = val;
                this.changeLine(line, val);
                return;
            }

            // ➕ QTY PLUS
            if (e.target.closest(SELECTORS.qtyPlus)) {
                e.preventDefault();
                const input = row.querySelector(SELECTORS.qtyInput);
                const val = parseInt(input.value, 10) + 1;
                input.value = val;
                this.changeLine(line, val);
            }
        }


        onChange(e) {
            if (!e.target.matches(SELECTORS.qtyInput)) return;
            const row = e.target.closest(SELECTORS.item);
            const line = parseInt(row.dataset.line, 10);
            const val = Math.max(0, parseInt(e.target.value) || 1);
            e.target.value = val;
            this.changeLine(line, val);
        }
    }

    /* =====================================================
   🌀 WEAR WITH IT — SWIPER INIT (CART SAFE)
===================================================== */

    function initsolomonWearSwiper(scope = document) {
        scope.querySelectorAll('[data-wear-with-it]').forEach((el) => {

            // ⛔ already initialized → destroy (AJAX safe)
            if (el.swiper) {
                el.swiper.destroy(true, true);
                el.swiper = null;
            }

            // 🔥 CRITICAL: drawer animation + DOM settle wait
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {

                    // ❌ still hidden → skip
                    if (el.offsetWidth === 0) return;

                    el.swiper = new Swiper(el, {
                        slidesPerView: 1.3,
                        spaceBetween: 0,
                        grabCursor: true,
                        watchOverflow: true,
                        observer: true,
                        observeParents: true,
                        slidesOffsetBefore: 10,
                        slidesOffsetAfter: 10,

                        navigation: {
                            nextEl: el.querySelector('.wear-with-it-swiper-button-next'),
                            prevEl: el.querySelector('.wear-with-it-swiper-button-prev'),
                        },

                        breakpoints: {
                            750: {
                                slidesPerView: 1.3,
                                spaceBetween: 0,
                                slidesOffsetBefore: 20,
                                slidesOffsetAfter: 20,
                            },
                            990: {
                                slidesPerView: 1.3,
                                spaceBetween: 0,
                                slidesOffsetBefore: 20,
                                slidesOffsetAfter: 20,
                            }
                        }
                    });
                });
            });
        });
    }



    if (!customElements.get("solomon-cart-drawer")) {
        customElements.define("solomon-cart-drawer", solomonCartDrawer);
    }
    document.addEventListener("solomon:discount:urgency", (e) => {

        fireCanvasConfetti();

        // GA4 safe
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "discount_applied_urgency",
            urgency_step: e.detail.step,
            urgency_percent: e.detail.percent
        });
    });

    // ─────────────────────────────────────────────
    // COUPON CODE — uses /cart/update.json (Shopify native API)
    // Chips rendered server-side from cart.discount_applications
    // Validation via discount_codes[].applicable in API response
    // ─────────────────────────────────────────────
    (function initCoupon() {
        var drawerEl = document.getElementById('solomonCartDrawer');
        if (!drawerEl) return;

        var CART_UPDATE_URL = '/cart/update.json';
        var SECTION_ID = 'solomon-cart-drawer';
        var activeFetch = null;

        function $el(sel)   { return drawerEl.querySelector(sel); }
        function $input()   { return $el('[data-coupon-input]'); }
        function $btn()     { return $el('[data-coupon-apply]'); }
        function $wrap()    { return $el('[data-coupon-input-wrap]'); }
        function $errEl()   { return $el('[data-coupon-error]'); }
        function $errCode() { return $el('[data-coupon-error-code]'); }
        function $errShip() { return $el('[data-coupon-error-shipping]'); }

        // Read currently applied codes from server-rendered DOM
        function getExistingCodes() {
            var codes = [];
            drawerEl.querySelectorAll('[data-discount-code]').forEach(function(el) {
                var c = el.getAttribute('data-discount-code');
                if (c) codes.push(c);
            });
            return codes;
        }

        // Dummy getSavedCodes/saveCodes for compatibility
        function getSavedCodes() { return getExistingCodes(); }
        function saveCodes()     {} // no-op — server is source of truth

        function setLoading(loading) {
            var b = $btn();
            if (!b) return;
            b.textContent = loading ? '...' : 'Apply';
            b.disabled = loading;
        }

        function showError(type) {
            var err = $errEl(), ec = $errCode(), es = $errShip(), w = $wrap();
            if (err) err.classList.remove('hidden');
            if (type === 'discount_code') {
                if (ec) ec.classList.remove('hidden');
                if (es) es.classList.add('hidden');
            } else {
                if (es) es.classList.remove('hidden');
                if (ec) ec.classList.add('hidden');
            }
            if (w) w.classList.add('solomon-coupon__input-wrap--error');
        }

        function hideError() {
            var err = $errEl(), ec = $errCode(), es = $errShip(), w = $wrap();
            if (err) err.classList.add('hidden');
            if (ec) ec.classList.add('hidden');
            if (es) es.classList.add('hidden');
            if (w) w.classList.remove('solomon-coupon__input-wrap--error');
        }

        function doRefresh() {
            var drawer = document.getElementById('solomonCartDrawer');
            if (drawer && typeof drawer.refresh === 'function') {
                drawer.refresh({ openIfClosed: false });
            }
        }

        // POST to /cart/update.json — Shopify native API for discount apply/remove
        function cartUpdate(discountStr) {
            if (activeFetch) activeFetch.abort();
            var ctrl = new AbortController();
            activeFetch = ctrl;
            var payload = { discount: discountStr, sections: [SECTION_ID] };
            console.log('[Coupon] cartUpdate payload:', JSON.stringify(payload));
            return fetch(CART_UPDATE_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(payload),
                credentials: 'same-origin',
                signal: ctrl.signal
            })
            .then(function(r) {
                console.log('[Coupon] cartUpdate HTTP status:', r.status);
                return r.json();
            })
            .finally(function() { activeFetch = null; });
        }

        function applyCode() {
            var inp = $input();
            var code = ((inp ? inp.value : '') || '').trim().toUpperCase();
            if (!code) { showError('discount_code'); return; }

            var existing = getExistingCodes();
            if (existing.indexOf(code) !== -1) return;

            hideError();
            setLoading(true);

            cartUpdate(existing.concat(code).join(','))
                .then(function(data) {
                    var dCodes = data.discount_codes || [];

                    // Invalid code — explicitly not applicable
                    if (dCodes.some(function(d) { return d.code === code && d.applicable === false; })) {
                        if (inp) inp.value = '';
                        showError('discount_code');
                        return;
                    }

                    // Shipping-only discount (applicable but not reflected as product discount)
                    var sectionHtml = data.sections && data.sections[SECTION_ID];
                    if (sectionHtml) {
                        var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
                        var newCodes = Array.from(parsed.querySelectorAll('[data-discount-code]'))
                            .map(function(el) { return el.getAttribute('data-discount-code'); });
                        var applicable = dCodes.some(function(d) { return d.code === code && d.applicable === true; });
                        if (newCodes.length === existing.length && applicable) {
                            if (inp) inp.value = '';
                            showError('shipping');
                            return;
                        }
                    }

                    // Success — clear input, refresh drawer (server re-renders chips from cart.discount_applications)
                    if (inp) inp.value = '';
                    hideError();
                    doRefresh();
                })
                .catch(function() { showError('discount_code'); })
                .finally(function() { setLoading(false); });
        }

        function removeCode(codeToRemove) {
            var existing = getExistingCodes();
            console.log('[Coupon] removeCode called, removing:', codeToRemove, '| existing:', existing);
            var remaining = existing.filter(function(c) { return c !== codeToRemove; });
            console.log('[Coupon] remaining codes after remove:', remaining);
            console.log('[Coupon] POSTing to', CART_UPDATE_URL, 'with discount:', remaining.join(','));
            cartUpdate(remaining.join(','))
                .then(function(data) {
                    console.log('[Coupon] cartUpdate response:', data);
                    doRefresh();
                })
                .catch(function(err) { console.error('[Coupon] removeCode error:', err); });
        }

        // After cart refresh: just reset input, chips come from server
        function resetState() {
            var inp = $input();
            if (inp) inp.value = '';
            hideError();
        }

        window._solomonCouponReset = resetState;

        // Event delegation
        drawerEl.addEventListener('click', function(e) {
            console.log('[Coupon] click target:', e.target, '| tag:', e.target.tagName, '| attrs:', e.target.outerHTML.slice(0, 120));

            if (e.target.closest('[data-coupon-toggle]')) {
                var f = $form();
                // console.log('[Coupon] toggle clicked, form:', f, 'current display:', f?.style.display);
                if (f) {
                        setTimeout(function() { var i = $input(); if (i) i.focus(); }, 50);
                }
                return;
            }

            if (e.target.closest('[data-coupon-apply]')) {
                console.log('[Coupon] APPLY clicked');
                applyCode();
                return;
            }

            // data-remove-code is set in Liquid on the chip remove button
            var removeBtn = e.target.closest('[data-remove-code]');
            if (removeBtn) {
                var code = removeBtn.getAttribute('data-remove-code');
                console.log('[Coupon] REMOVE clicked, code:', code);
                console.log('[Coupon] existing codes before remove:', getExistingCodes());
                removeCode(code);
                return;
            }
        });

        drawerEl.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' && e.target.closest('[data-coupon-input]')) {
                e.preventDefault();
                applyCode();
            }
            if (e.key === 'Escape' && e.target.closest('[data-coupon-input]')) {
                var f = $form(); if (f) f.style.display = 'none';
            }
        });
    })();

    /* =====================================================
   🔁 Dawn cartUpdate binding (safe retry)
===================================================== */
    (function bindsolomonCartUpdate(retry = 0) {
        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                const cart = event.cartData;
                if (!cart) return;

                /* ✅ Cart count bubble (theme-level) */
                document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
                    const visible = bubble.querySelector('span[aria-hidden]');
                    const hidden = bubble.querySelector('.visually-hidden');

                    if (visible) visible.textContent = cart.item_count;
                    if (hidden) hidden.textContent = `${cart.item_count} items`;

                    bubble.classList.toggle('hidden', cart.item_count === 0);
                });

                /* ✅ Refresh solomon Cart Drawer */
                const drawer = document.querySelector('solomon-cart-drawer');
                if (drawer && typeof drawer.refresh === "function") {
                    drawer.refresh({ openIfClosed: true });
                }
            });
        } else if (retry < 10) {
            setTimeout(() => bindsolomonCartUpdate(retry + 1), 50);
        }
    })();


})();

